function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNextIcon = function SvgNextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.76 21.399 14.368 37.42a2.06 2.06 0 0 1-2.863 0l-1.912-1.868a1.947 1.947 0 0 1-.003-2.795L22.58 20 9.59 7.243a1.947 1.947 0 0 1 .003-2.795l1.912-1.868a2.06 2.06 0 0 1 2.863 0L30.76 18.6c.79.773.79 2.025 0 2.798z",
    style: {
      transform: "scale(25)"
    }
  }));
};
export default SvgNextIcon;